import { ref, reactive, computed } from "vue";
import { ElMessage } from "element-plus";
import publicStore from "@/store/publicStore";

const showVIPDialogue = ref(false);
const showUserServiceDialogue = ref(false);
const showLogoutDialogue = ref(false);
const showEditChatTitleDialogue = ref(false);
const showDeleteChatDialogue = ref(false);
const showPayCodeDialogue = ref(false);
const editForm = reactive({
  index: 0,
  content: "",
});

const openVIP = () => {
  const store = publicStore();

  const info = store.vipInfo;
  console.log("info");
  if (info.permanent === 1) {
    ElMessage.warning("您已是永久VIP会员");
    return;
  }
  showVIPDialogue.value = true;
};

const serviceLink = `https://tb.53kf.com/code/client/e5737fde24ca205cd5bfe7a693f625822/9 `;

const openService = () => {
  window.open(serviceLink, "_blank");
};

export {
  editForm,
  showVIPDialogue,
  showUserServiceDialogue,
  showLogoutDialogue,
  showEditChatTitleDialogue,
  showDeleteChatDialogue,
  showPayCodeDialogue,
  openVIP,
  openService,
};
